module.exports = __webpack_public_path__ + "static/media/ggj2-2019.216ba18e.jpg";